import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpHelper } from '../helpers/http-helper';
import { AuthenticationService } from './authentication.service';
import { SettingsService } from './settings.service';
import { StorageManagerService } from './storage-manager.service';
import { IApiResult } from '../models/api-result';
import { ILLProductDashboard } from '../models/ll-product-dashboard';
@Injectable()
export class ProductDashboardService {

    httpHelper: HttpHelper;

    constructor (private http: HttpClient, private settingsService: SettingsService, private authService: AuthenticationService, private storageManagerService: StorageManagerService) {
        // Define an instance of the http helper class that will be used to create httpHeader for api calls
        this.httpHelper = new HttpHelper(http, authService, storageManagerService);
    }

    getProductDashboard(revisionId: number): Observable<ILLProductDashboard> {
        const headers = this.httpHelper.createHttpHeaders();
        const settings = this.settingsService.getSettings();

        const url = `${settings.ApiGatewayUrl}/ssdpds/v1/LLForms/ProductDashboard/${revisionId}`;

        return this.http.get(url, { headers: headers })
        .pipe(map(this.extractData),
            map(p => p.data),
            catchError(this.handleErrors));
    }

    updateHeaderFields(llId: number, productName: string, businessCategoryId: number, modifiedByUser: string)  {
      let headers = this.httpHelper.createHttpHeaders();
      const settings = this.settingsService.getSettings();
      headers = headers.set('modifiedByUser', modifiedByUser);

      const llData = {
        'businessCategoryId': businessCategoryId,
        'productName': productName,
        'llId': llId
      };

      const url = `${settings.ApiGatewayUrl}/ssdpds/v1/LLForms/UpdateProductDashboard`;

      return this.http.post(url, llData, { headers: headers })
        .pipe(map(this.extractData),
          catchError(this.handleErrors));
    }
    
    private extractData(response: any) {
        if (response.status < 200 || response.status >= 300) {
            throw new Error('Bad response status: ' + response.status);
        }
        const body = response as IApiResult;
            return body;
        }
        
    // Error handling
    private handleErrors(error: any): Observable<any> {
        const GENERIC_ERROR_MSG = 'It looks like something went wrong. Try reloading the page or contacting support if this issue continues.';
        const bDisplayDetailMsg = error && error.error && error.error.isBusinessErrorMessage ? true : isDevMode() ? true : false;
        error.error = error && error.error && error.error.message && bDisplayDetailMsg ? error.error.message : GENERIC_ERROR_MSG;

        return throwError(error.error);
    }
}
